// import media files
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar8 from 'assets/images/avatar/avatar-8.jpg';

// import courses media files
import BootstrapCourse from 'assets/images/course/course-bootstrap.jpg';

export const BootstrapCoursesData = [
	{
		id: 1,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'An Ultimate Guide for Beginners Bootstrap 5',
		instructor_name: 'Morris Mccoy',
		instructor_image: Avatar3,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 2,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'How to customize Bootstrap CSS for Beginner',
		instructor_name: 'Ted Hawkins',
		instructor_image: Avatar2,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 7800
	},
	{
		id: 3,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Bootstrap 5 Grid System Introduction for Beginner',
		instructor_name: 'Juanita Bell',
		instructor_image: Avatar4,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 8245
	},
	{
		id: 4,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Easy Way to Work with Bootstrap 5 Components',
		instructor_name: 'Claire Robertson',
		instructor_image: Avatar5,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 3245
	},

	{
		id: 5,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Bootstrap Tutorial - How to Set Up and Use Bootstrap',
		instructor_name: 'Morris Mccoy',
		instructor_image: Avatar5,
		level: 'Intermediate',
		duration: '3h 56m',
		rating: 4.0,
		ratingby: 5300
	},
	{
		id: 6,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Bootstrap 5 Components Alerts Customization',
		instructor_name: 'Ted Hawkins',
		instructor_image: Avatar6,
		level: 'Intermediate',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 7,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Customization Bootstrap 5 Components Accordion /Tab',
		instructor_name: 'Juanita Bell',
		instructor_image: Avatar7,
		level: 'Intermediate',
		duration: '1h 30m',
		rating: 4.0,
		ratingby: 5568
	},
	{
		id: 8,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Preparing a site to go live with Gatsby Server',
		instructor_name: 'Claire Robertson',
		instructor_image: Avatar8,
		level: 'Intermediate',
		duration: '2h 30m',
		rating: 4.0,
		ratingby: 6245
	},
	{
		id: 9,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'How to Build Custom Bootstrap Theme',
		instructor_name: 'Claire Robertson',
		instructor_image: Avatar8,
		level: 'Advance',
		duration: '2h 30m',
		rating: 4.0,
		ratingby: 6245
	},
	{
		id: 10,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Bootstrap 5 tutorial - Learn Bootstrap by Building a page',
		instructor_name: 'Juanita Bell',
		instructor_image: Avatar7,
		level: 'Advance',
		duration: '1h 30m',
		rating: 4.0,
		ratingby: 5568
	},
	{
		id: 11,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'How to Build Admin Dashboard Bootstrap 5',
		instructor_name: 'Ted Hawkins',
		instructor_image: Avatar6,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 12,
		category: 'bootstrap',
		image: BootstrapCourse,
		title: 'Advance Bootstrap SCSS Theme Customization',
		instructor_name: 'Morris Mccoy',
		instructor_image: Avatar5,
		level: 'Advance',
		duration: '3h 56m',
		rating: 4.0,
		ratingby: 5300
	}
];

export default BootstrapCoursesData;
